import "./announcement.css";
import { FaCircleExclamation } from "react-icons/fa6";

export default function Announcement(props) {
  return (
    <>
      <div
        class="announcement-mobile-padding"
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: props.color,
          // borderRadius: "7px",
          // height: "10%",
          color: "#000",
          padding: "0.5%",
          marginBottom: "1%",
          
        }}
      >
        <span style={{ width: "100%", textAlign: "center", padding: "2px" }}>
          <FaCircleExclamation color={"white"} />

          <ins
            style={{
              color: "white",
              textDecoration: "none",
              fontWeight: 500,
              marginLeft: "1%",
            }}
          >
            {props.message}
          </ins>
        </span>
      </div>
    </>
  );
}
